<template>
  <div class="d-flex align-items-center">
    <span>
      <b-button
        v-if="document_info.doc_type === 'file' && getFileHref"
        class="btn-skep"
        @click.prevent="downloadFile(document_info.title, getFileHref, print_mode)"
      >
        <b-link
          class="custom-attach-businesscase"
          :href="print_mode ? getFileHref : '#'"
          target="_blank"
        >
          {{ lang !== 'ENG' ? document_info.title : document_info.translated?.title_e }}
          <span v-if="fileIcon === 'document'">
            <svg
              width="20"
              height="20"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.38235 3.19765H3.90295V13.8023H12.097V6.13417M9.38235 3.19765L12.097 6.13417M9.38235 3.19765V6.13417H12.097"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <span v-else-if="fileIcon === 'image'">
            <svg
              width="20"
              height="20"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.38235 3.19765H3.90295V13.8023H12.097V6.13417M9.38235 3.19765L12.097 6.13417M9.38235 3.19765V6.13417H12.097"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <span v-else class="icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.38235 3.19765H3.90295V13.8023H12.097V6.13417M9.38235 3.19765L12.097 6.13417M9.38235 3.19765V6.13417H12.097"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </span>
        </b-link>
      </b-button>

      <a
        v-else-if="document_info.doc_type === 'link'"
        class="btn-skep mr-3 mb-2 custom-attach-businesscase d-inline-flex align-items-center"
        :href="lang !== 'ENG' ? document_info.link : document_info.translated?.link"
        target="_blank"
      >
        {{ lang !== 'ENG' ? document_info.title : document_info.translated?.title_e }}
        <span class="document-icon">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_876_3244)">
              <path d="M3.05725 12.9425L12.0283 3.97159" stroke="currentColor" stroke-width="2" />
              <path d="M12.4422 2.55688L12.4423 10.987" stroke="currentColor" stroke-width="2" />
              <path d="M13.4431 3.55776L5.01297 3.55774" stroke="currentColor" stroke-width="2" />
            </g>
            <defs>
              <clipPath id="clip0_876_3244">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
      </a>

      <a
        v-else-if="document_info.doc_type === 'storyboard'"
        class="btn-skep mr-3 mb-2 custom-attach-businesscase d-inline-flex align-items-center"
        :href="lang !== 'ENG' ? document_info.link : document_info.translated?.link"
        target="_blank"
      >
        {{ lang !== 'ENG' ? document_info.title : document_info.translated?.title_e }}
        <span class="document-icon">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_876_3244)">
              <path d="M3.05725 12.9425L12.0283 3.97159" stroke="currentColor" stroke-width="2" />
              <path d="M12.4422 2.55688L12.4423 10.987" stroke="currentColor" stroke-width="2" />
              <path d="M13.4431 3.55776L5.01297 3.55774" stroke="currentColor" stroke-width="2" />
            </g>
            <defs>
              <clipPath id="clip0_876_3244">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
      </a>
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { downloadFile } from '../../../util';
export default {
  name: 'DocumentSb',
  props: {
    document_id: { type: [String, Number], default: '' },
    document_info: {
      type: Object,
      default() {
        return {};
      }
    },
    print_mode: { type: Boolean, default: false }
  },
  computed: {
    ...mapState('report_list', ['lang']),
    fileIcon() {
      return this.getFileIcon(this.document_info.path);
    },
    getFileHref() {
      return this.lang !== 'ENG'
        ? this.$store.state.static_host + this.document_info.path
        : this.document_info.translated?.path
        ? this.$store.state.static_host + this.document_info?.translated?.path
        : '';
    }
  },
  methods: {
    downloadFile,
    getFileIcon(filePath) {
      if (filePath) {
        const ext = filePath.split('.').pop().toLowerCase();
        if (['pdf', 'json', 'docx', 'doc', 'hwp'].includes(ext)) return 'document';
        if (['jpg', 'jpeg', 'png', 'svg', 'gif'].includes(ext)) return 'image';
      }
      return 'link';
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-attach-businesscase {
  color: inherit;
}

.custom-attach-businesscase:focus,
.custom-attach-businesscase:active,
.custom-attach-businesscase:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

.icon {
  margin-left: 1rem;
}
</style>
